import { showFailed } from "../../Customs/SweetAlerts";
import axiosInstance from "../../Middleware/AxiosInstanceInterceptor";

// Add Role
export const addRole = async (formData) => {
    const updatedData = {
        name: formData.name,
    }
    try {
        const response = await axiosInstance.post(`/roles`, updatedData);
        const data = response.data;

        if (response.status === 200) {
            return data;
        }
        else {
            showFailed('Failed.', `${response.status}`);
        }
    }
    catch (error) {
        showFailed('Failed.', `${error.response.statusText}`);
    }
}

// Update Role
export const updateRole = async (formData, userId) => {
    const updatedData = {
        name: formData.name,
    }
    try {
        const response = await axiosInstance.patch(`/roles/${userId}`, updatedData);
        const data = response.data;

        if (response.status === 200) {
            return data;
        } else {
            showFailed('Failed.', `${response.status}`);
        }
    } catch (error) {
        showFailed('Failed.', `${error.response.data.error[0]}`);
    }
};

// Delete Role
export const deleteRole = async (userId) => {
    try {
        const response = await axiosInstance.delete(`/roles/${userId}`);
        const data = response.data;

        if (response.status === 200) {
            return data;
        } else {
            showFailed('Failed.', `${response.status}`);
        }
    } catch (error) {
        showFailed('Failed.', `${error.response.data.error[0]}`);
    }
};